// extracted by mini-css-extract-plugin
export default {"btns":"DayChooser_btns__mjYoK","disabled":"DayChooser_disabled__3yqas","icon":"DayChooser_icon__bubh6","none":"DayChooser_none__uaAjJ","rotate":"DayChooser_rotate__Nd1B5"};